import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByCategory',
  pure: true // mantiene el rendimiento
})
export class FilterByCategoryPipe implements PipeTransform {
  transform(images: any[], category: string): any[] {
    if (!images) return [];
    if (!category) return images;
    return images.filter(img => img.category === category);
  }
}
